import { createContext, type Context } from "react";
import type {
  AnalyticsScopeName,
  AnalyticsScopes,
  CoachingAnalyticsScope,
  TeammatePageAnalyticsScope,
} from "./scopes.js";

type AnalyticsScopeContexts = {
  [K in AnalyticsScopeName]: Context<AnalyticsScopes[K] | undefined>;
};

/** One React context per scope keeps named consumer subscriptions isolated. */
export const analyticsScopeContexts: AnalyticsScopeContexts = {
  teammatePage: createContext<TeammatePageAnalyticsScope | undefined>(
    undefined,
  ),
  coaching: createContext<CoachingAnalyticsScope | undefined>(undefined),
};

export function getAnalyticsScopeContext<K extends AnalyticsScopeName>(
  scope: K,
): Context<AnalyticsScopes[K] | undefined> {
  return analyticsScopeContexts[scope];
}
